export default __webpack_public_path__ + "assets/img/ff55e88df15dd04a0ad49a2a730034e5.svg";